import { PageEffectiveShopParam, EffectiveShopVo } from '@servicesTypings/companyRequest'
import {
    ListAgSettingConfigResult,
    ModifyAgEnableStatusParam,
    ModifyAgLaterParam,
    ModifyReceiptGoodsAutoRefundStatusParam
} from '@servicesTypings/towerAftersaleRequest'
import { companyRequest, towerAftersaleRequest } from '@/utils/request'

// 查询有效的店铺数据列表
/**
 * 查询有效的店铺数据列表
 */
export function pageEffectiveShopApi(data: PageEffectiveShopParam): API.Res<EffectiveShopVo[]> {
    return companyRequest.post('/shop/pageEffectiveShop', { data })
}

// 根据店铺id列表查询ag规则
/**
 * 根据店铺id列表查询ag规则
 */
export function listAgSettingConfigApi(data: integer[]): API.Res<ListAgSettingConfigResult[]> {
    return towerAftersaleRequest.post('/agSetting/listAgSettingConfig', { data })
}

// 修改ag启用状态
/**
 * 修改ag启用状态
 */
export function modifyAgEnableStatusApi(data: ModifyAgEnableStatusParam): API.Res<object> {
    return towerAftersaleRequest.post('/agSetting/modifyAgEnableStatus', { data })
}

// 修改ag延迟执行数据
/**
 * 修改ag延迟执行数据
 */
export function modifyAgLaterApi(data: ModifyAgLaterParam): API.Res<object> {
    return towerAftersaleRequest.post('/agSetting/modifyAgLater', { data })
}

// 修改AG确认收货自动退款状态
/**
 * 修改AG确认收货自动退款状态
 */
export function modifyReceiptGoodsAutoRefundStatusApi(data: ModifyReceiptGoodsAutoRefundStatusParam): API.Res<object> {
    return towerAftersaleRequest.post('/agSetting/modifyReceiptGoodsAutoRefundStatus', { data })
}
